// A máscara e a validação do CPF ou CNPJ da fonte pagadora, portadas de `src/lib/carne-leao.ts` da Central do
// Perito (03/11, 000385). A validação é a de lá, pelo tamanho (11 ou 14 dígitos), e é a mesma do `check` do
// banco: uma regra mais estrita aqui recusaria na tela o que o banco aceita, e o contrário perderia a
// gravação na fila.

export function mascaraCpfCnpj(v: string): string {
  const d = v.replace(/\D/g, "").slice(0, 14);
  if (d.length <= 11) {
    return d
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d{1,2})$/, ".$1-$2");
  }
  return d
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
}

export function cpfCnpjValido(v: string): boolean {
  const d = v.replace(/\D/g, "");
  return d.length === 11 || d.length === 14;
}
